module.exports = __webpack_public_path__ + "static/img/wok.1b7aa68.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wok.gif
// module id = ITYY
// module chunks = 4